import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";
import { PopulatedProjectFile } from "../../__generated__/types";

const GET_DESIGNER_PROJECT_FILES = gql`
  query GetDesignerProjectFiles($designerId: ID!) {
    getDesignerProjectFiles(designerId: $designerId) {
      _id
      name
      description
      style
      projectCategory
      projectStyle
      specialRequirements
      budgetRange
      squareFootage
      projectDuration
      images {
        _id
        url
        path
        title
        credit
        description
      }
      displayOrder
      featuredOnBio
      published
    }
  }
`;

export const useGetDesignerProjectFiles = () => {
  const [getDesignerProjectFilesQuery, { loading, error, data }] = useLazyQuery(
    GET_DESIGNER_PROJECT_FILES
  );

  const getDesignerProjectFiles = useCallback(
    async (designerId: string, refresh: boolean = false) => {
      try {
        const result = await getDesignerProjectFilesQuery({
          variables: { designerId },
          fetchPolicy: refresh ? "network-only" : "cache-first",
        });
        return result.data?.getDesignerProjectFiles ?? [];
      } catch (error) {
        console.error("Error fetching designer project files:", error);
        throw error;
      }
    },
    [getDesignerProjectFilesQuery]
  );
  return {
    getDesignerProjectFiles,
    loading,
    error,
    designerProjectFiles: (data?.getDesignerProjectFiles ||
      []) as PopulatedProjectFile[],
  };
};
